/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemWithExpiresOnRef,
  LineItemWithExpiresOnRefOptional,
  LineItemWithExpiresOnRefMetaI,
  LineItemWithExpiresOnRefTrackedI,
} from "./line-item-with-expires-on-ref";
import {
  LineItemWithExpiresOnRefTracked,
  LineItemWithExpiresOnRefMeta,
} from "./line-item-with-expires-on-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";

/**
 *
 * @export
 * @interface LineItemOrderRef
 */
export interface LineItemOrderRefOptional extends LineItemWithExpiresOnRefOptional {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemOrderRef
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemOrderRef
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemOrderRef
   */
  referenceId?: string;
  /**
   *
   * @type {OrderRef}
   * @memberof LineItemOrderRef
   */
  orderId?: OrderRefOptional;
}

export interface LineItemOrderRef
  extends LineItemOrderRefOptional, LineItemWithExpiresOnRef {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemOrderRef
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemOrderRef
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof LineItemOrderRef
   */
  referenceId?: string;
  /**
   *
   * @type {OrderRef}
   * @memberof LineItemOrderRef
   */
  orderId: OrderRef;
}

export interface LineItemOrderRefTrackedI extends LineItemWithExpiresOnRefOptional {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemOrderRef
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemOrderRef
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemOrderRef
   */
  referenceId?: string;
  referenceIdIsSet: boolean;
  /**
   *
   * @type {OrderRef}
   * @memberof LineItemOrderRef
   */
  orderId?: OrderRefTrackedI;
  orderIdIsSet: boolean;
}

transformDatesMap.set("LineItemOrderRef", function (model: LineItemOrderRef) {
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
  const transformDatesorderId = transformDatesMap.get("OrderRef");
  if (transformDatesorderId && model.orderId) {
    transformDatesorderId(model.orderId);
  }
});

export type LineItemOrderRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referenceId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  orderId: PropertyMeta<OrderRefMetaI>;
}>;

export var LineItemOrderRefMeta: LineItemOrderRefMetaI =
  {} as LineItemOrderRefMetaI;
LineItemOrderRefMeta = typeMeta("LineItemOrderRef", {
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referenceId: propertyMeta(
    "referenceId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  orderId: propertyMeta("orderId", false, true, false, OrderRefMeta),
});

const metaI = LineItemOrderRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([LineItemWithExpiresOnRefMeta]);
  metaI.expiresOn.inheritedFrom = LineItemWithExpiresOnRefMeta.expiresOn;
  metaI.assignId.inheritedFrom = LineItemWithExpiresOnRefMeta.assignId;
  metaI.referenceId.inheritedFrom = LineItemWithExpiresOnRefMeta.referenceId;
});

export class LineItemOrderRefTracked
  extends LineItemWithExpiresOnRefTracked
  implements LineItemOrderRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referenceId__I?: string = undefined;
  referenceIdIsSet: boolean = false;
  set referenceId(v: undefined | string) {
    if (v !== undefined) {
      this.referenceId__I = v;
      this.referenceIdIsSet = true;
    } else {
      this.referenceId__I = v || undefined;
      this.referenceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get referenceId() {
    return this.referenceId__I;
  }
  orderId__I?: OrderRefTracked = undefined;
  orderIdIsSet: boolean = false;
  set orderId(v: undefined | OrderRefTracked) {
    if (v !== undefined) {
      this.orderId__I = v;
      this.orderIdIsSet = true;
    } else {
      this.orderId__I = v || undefined;
      this.orderIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get orderId() {
    return this.orderId__I;
  }
  constructor(config?: LineItemOrderRefOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.referenceIdIsSet == true && other?.referenceIdIsSet == true)
      return this.referenceId == other.referenceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.orderId?.setIds();
  }
  assignFrom(
    config: LineItemOrderRefOptional,
    options?: AssignOptions,
  ): LineItemOrderRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referenceId &&
      this.referenceIdApplyFilter(optionsRequired.filter)
    ) {
      this.referenceId = config.referenceId;
      if (optionsRequired.unassign) this.referenceIdIsSet = false;
      else this.referenceIdIsSet = true;
    }
    if (config.orderId && this.orderIdApplyFilter(optionsRequired.filter)) {
      this.orderId = new OrderRefTracked(config.orderId, options);
      if (optionsRequired.unassign) this.orderIdIsSet = false;
      else this.orderIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemOrderRefTrackedI {
    const cloned = {} as LineItemOrderRefTrackedI;
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referenceIdIsSetDeep() &&
      this.referenceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referenceIdIsSet = true;
      cloned.referenceId = this.referenceId;
    } else {
      //cloned.referenceIdIsSet = false
    }
    if (
      this.orderIdIsSetDeep() &&
      this.orderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIdIsSet = true;
      cloned.orderId = this.orderId?.removeUnset(filter);
    } else {
      //cloned.orderIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemOrderRefTrackedI {
    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referenceIdApplyFilter(filter)) this.referenceIdIsSet = false;

    if (!this.orderIdApplyFilter(filter)) this.orderIdIsSet = false;
    this.orderId?.unassignAll(filter);

    return this;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemOrderRefMeta.expiresOn,
      LineItemOrderRefMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemOrderRefMeta.assignId,
      LineItemOrderRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referenceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemOrderRefMeta.referenceId,
      LineItemOrderRefMeta,
      this.referenceId,
      this,
    );
  }
  referenceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referenceIdIsSet && this.referenceIdApplyFilter(filter))
      return true;

    return false;
  }
  orderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemOrderRefMeta.orderId,
      LineItemOrderRefMeta,
      this.orderId,
      this,
    );
  }
  orderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIdIsSet && this.orderIdApplyFilter(filter)) return true;
    return this.orderId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referenceIdIsSetDeep(filter)) return true;
    if (this.orderIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
